<template>
  <div class="c-material-lifecycle">
    <div class="c-form">
      <div class="material-info-row">
        <span>
          素材ID：
          <span class="text">{{ id }}</span>
        </span>
        <span>
          素材名称：
          <span class="text">{{ name }}</span>
        </span>
        <span>
          设计者：
          <span class="text">{{ author }}</span>
        </span>
        <span>
          上传时间：
          <span class="text">{{ creatime }}</span>
        </span>

        <span>
          起投时间：
          <span class="text">{{ begintime }}</span>
        </span>

        <span>
          最后投放时间：
          <span class="text">{{ endtime }}</span>
        </span>
      </div>

      <ElForm inline label-width="74px" @submit.native.prevent class="elementui-common-form-styles" v-highlight>
        <ElFormItem label="媒体" label-width="40px">
          <el-select v-model="mediaId" clearable @change="queryAction" style="width: 110px" placeholder="全部">
            <el-option v-for="item in MEDIAS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="统计时间">
          <DateRangePicker v-model="datetime" :clearable="false" @change="handleDatetime" style="width: 220px"></DateRangePicker>
        </ElFormItem>
      </ElForm>
    </div>
    <div class="c-m-table">
      <Tabs v-model="platform" @on-click="queryAction" class="c-table-list">
        <TabPane name="0" label="全部"></TabPane>
        <TabPane name="1" label="Andriod"></TabPane>
        <TabPane name="2" label="iOS"></TabPane>
        <template slot="extra">
          <Button @click="modalColumn = true">自定义列</Button>
          <Button icon="md-download" @click="downData" style="margin-left: 2px">数据导出</Button>
        </template>
      </Tabs>

      <div class="c-compare-wrap">
        <div class="c-compare-form">
          <Select v-model="referEc" style="width: 180px">
            <Option v-for="drop in referEcDrop" :key="drop.key" :value="drop.key">{{ drop.title }}</Option>
          </Select>
          <Checkbox v-model="isRefer" @on-change="changeRefer" style="margin: 0 8px">对比</Checkbox>
          <Select v-if="isRefer" v-model="compareEc" style="width: 180px">
            <Option v-for="drop in compareEcDrop" :key="drop.key" :value="drop.key">{{ drop.title }}</Option>
          </Select>
        </div>
        <div class="c-echarts">
          <compare-echart :loading="loading" :compare-options="echartsOptions" />
        </div>
      </div>
      <Viewport v-model="tableHeight">
        <lifecycle-table
          :height="tableHeight"
          :loading="loading"
          :data="tableList"
          :columns="tableCol"
          :summary="summaries"
          @on-sort="sortTable"
        />
        <Page
          show-total
          show-elevator
          class="c-table-page pager"
          size="small"
          :total="total"
          :current.sync="pageIndex"
          :page-size="10"
          @on-change="changePIndex"
        />
      </Viewport>
    </div>
    <!-- 自定义列 -->
    <custom-column
      v-model="modalColumn"
      :data="columns"
      :sub-title="['报表数据', '创角留存', '创角LTV', '视频数据']"
      @on-select="selectColumn"
    />
  </div>
</template>
<script>
import moment from 'moment'
import { mul } from '@/common/js/api'
import { isArray } from '@/common/js/utils'
import { toThousands, toPercentFixed, datetimeToDay } from '@/common/js/filters'
import { HOST_API } from '@/api/config'

import mixinTable from './mixin_table'
import columns from '../data/material_record_life_column'
import DateRangePicker from '@/components/date-range-picker/index.vue'
import CustomColumn from '@/components/converter/custom-column.vue'
import CompareEchart from '@/components/echarts/echart.vue'
import theme from '@/components/echarts/theme'
import LifecycleTable from './components/lifecycle-table'
import { getMaterialLifeCycle, getMaterialAnalysisDailyData } from '@/api/report.model'

import { initPageData, MEDIAS } from '@/data/global-opts'
const PAGE_REQUIRED_OPTS = initPageData([MEDIAS])

export default {
  name: 'materlifecycle',
  mixins: [mixinTable],
  components: { CustomColumn, LifecycleTable, DateRangePicker, CompareEchart },
  computed: {
    ...PAGE_REQUIRED_OPTS,
    tableCol() {
      return this.columns.filter((ret) => !ret.show)
    },
    referEcDrop() {
      return this.dropData.filter((ret) => ret.key !== this.compareEc)
    },
    compareEcDrop() {
      return this.dropData.filter((ret) => ret.key !== this.referEc)
    }
  },
  methods: {
    queryAction() {
      this.pageIndex = 1
      this.getData()
    },
    getData() {
      const [beginTime, endTime] = this.datetime || []

      const param = {
        platform: this.platform,
        imageId: this.id,
        beginTime,
        endTime,
        mediaId: this.mediaId,
        sort: this.sort,
        order: this.order
      }
      this.loading = true
      getMaterialLifeCycle(param).then((data) => {
        this.loading = false
        if (!data) return
        const { imageInfo, list, sumData } = data
        // 素材基本信息
        if (imageInfo) {
          const { imageName, designerName, uploadTime, adStartTime, adEndTime } = imageInfo
          this.name = imageName
          this.author = designerName
          this.creatime = typeof uploadTime === 'number' ? datetimeToDay(uploadTime) : uploadTime
          this.begintime = typeof adStartTime === 'number' ? datetimeToDay(adStartTime) : adStartTime
          this.endtime = typeof adEndTime === 'number' ? datetimeToDay(adEndTime) : adEndTime
        }
        if (isArray(list) && sumData) {
          this.sumData = sumData
          this.listData = list
          this.tableList = this.calcTableData()
          this.total = list.length
          this.creatEchart(this.referEc, this.compareEc)
        }
      })
    },
    calcTableData() {
      const start = (this.pageIndex - 1) * 10
      const end = 10 * this.pageIndex
      return this.listData.slice(start, end)
    },
    creatEchart(refer, compare) {
      const ecKeys = this.isRefer ? [refer, compare] : [refer]
      const tableList = JSON.parse(JSON.stringify(this.listData))
      const xAxisData = tableList.sort((a, b) => a.tdate - b.tdate).map((ret) => datetimeToDay(ret.tdate))
      const referData = tableList
        .sort((a, b) => a.tdate - b.tdate)
        .map((ret) => (refer.includes('Rate') ? mul(100, ret[refer]) : ret[refer]))
      const compareData = tableList
        .sort((a, b) => a.tdate - b.tdate)
        .map((ret) => (compare.includes('Rate') ? mul(100, ret[compare]) : ret[compare]))

      const legends = ecKeys.map((ret) => {
        const column = columns.filter((t) => t.key === ret).pop()
        return column.title
      })
      const yAxis = ecKeys.map((ret, i) => {
        const column = columns.filter((t) => t.key === ret).pop()
        let unit = ''
        if (ret.includes('Rate')) unit = '%'
        else if (['paperUseAmount', 'amount', 'activeCost', 'createRoleCost', 'sumRecharge', 'sumMoney'].includes(ret)) unit = '元'
        return {
          name: column.title,
          nameGap: 5,
          type: 'value',
          axisLabel: {
            formatter: `{value} ${unit}`
          }
        }
      })
      const series = ecKeys.map((ret, i) => {
        const column = columns.filter((t) => t.key === ret).pop()
        return {
          name: column.title,
          data: i ? compareData : referData,
          type: 'line',
          yAxisIndex: i
        }
      })
      const tooltips = ecKeys.map((ret, i) => {
        let unit = ''
        if (ret.includes('Rate')) unit = '%'
        else if (['paperUseAmount', 'amount', 'activeCost', 'createRoleCost', 'sumRecharge', 'sumMoney'].includes(ret)) unit = '元'
        return `<dd class="tooltop-span"><span style="background-color: ${theme.color[i]}"></span>{a${i}}: {c${i}} ${unit}</dd>`
      })
      let formatHtml = '<h3 class="tooltip-h3">{b0}</h3>'
      formatHtml += tooltips.join('')
      // 图表配置
      this.echartsOptions = {
        legend: {
          bottom: 0,
          itemGap: 20,
          itemWidth: 12,
          itemHeight: 6,
          align: 'right',
          data: legends
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          padding: 10,
          formatter: formatHtml
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: !0,
            position: 'bottom',
            offset: 0,
            data: xAxisData
          }
        ],
        yAxis,
        series,
        grid: { top: 35, left: 16, right: 16, bottom: 34, containLabel: !0 }
      }
    },
    summaries(param) {
      const { columns } = param
      const data = JSON.parse(JSON.stringify(this.sumData))
      const sums = []
      columns.forEach((column, index) => {
        const prop = column.property
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const numbers = [
          'pv',
          'clickNum',
          'paperUseAmount',
          'amount',
          'newRoleMoney',
          'sumRecharge',
          'sumMoney',
          'downNum',
          'newUserNum',
          'createRoleNum',
          'newRoleNum',
          'payRoleUserNum',
          'timeDiff'
        ]
        // 格式化数据格式
        if (numbers.includes(prop)) sums[index] = toThousands(data[prop])
        else if (prop?.indexOf('Rate') > -1) sums[index] = toPercentFixed(data[prop])
        else sums[index] = data[prop]
      })
      return sums
    },
    handleDatetime(dates) {
      const [start, end] = dates
      const limitDate = moment(end).subtract(90, 'days')

      if (limitDate.isAfter(start)) {
        this.$Message.warning('日期范围不能超过90天！')
        const newDate = limitDate.format('YYYY-MM-DD')
        this.datetime = [newDate, end]
      }

      this.pageIndex = 1
      this.getData()
    },
    changePIndex(index) {
      this.pageIndex = index
      this.tableList = this.calcTableData()
    },
    changeRefer(val) {
      this.isRefer = val
      !val && (this.compareEc = 'paperUseAmount')
      this.creatEchart(this.referEc, this.compareEc)
    },

    downData() {
      const [beginTime, endTime] = this.datetime || []
      const path = '/api/ptom/media/downloadMaterialLifeCycleData'

      const url = `${HOST_API}${path}?`

      const params = {
        sessionid: this.$store.state.token,
        platform: this.platform,
        mediaId: this.mediaId,
        imageId: this.id
      }

      if (beginTime && endTime) {
        params.beginTime = beginTime
        params.endTime = endTime
      }

      this.order && (params.order = this.order)
      this.sort && (params.sort = this.sort)

      const queryString = new URLSearchParams(params).toString()

      window.open(url + queryString)
    },
    proLoadData() {
      this.mediaId = Number(this.$route.query.mediaId) || ''
      // 渲染EC对比下拉框
      this.referEc = 'amount'
      this.compareEc = 'paperUseAmount'
      this.queryAction()
    }
  },
  data() {
    return {
      tableHeight: 330,
      id: this.$route.query.id,
      platform: String(this.$route.query.platform),
      name: null,
      author: null,
      creatime: null,
      begintime: null,
      endtime: null,
      mediaId: '',
      columns: [], // 表格字段
      tableList: [], // 表格数据
      listData: [], // 所有数据
      sumData: [], // 统计数据
      dropData: [], // 对比下拉数据
      isRefer: null, // 是否对比
      referEc: '',
      compareEc: '', // 对比字段
      echartsOptions: {},
      datetime: []
    }
  },
  watch: {
    columns: {
      handler(nVal) {
        const show = nVal.filter((ret) => !ret.show).map((met) => met.key)
        this.setCustomStorage('MaterLifeCustomColumn', show)
      },
      deep: true
    },
    referEc(nVal) {
      this.creatEchart(nVal, this.compareEc)
    },
    compareEc(nVal) {
      this.creatEchart(this.referEc, nVal)
    }
  },
  created() {
    const { beginTime, endTime } = this.$route.query
    const dropData = JSON.parse(JSON.stringify(columns))
    dropData.shift()
    this.datetime = [beginTime, endTime]
    this.dropData = dropData
    const shows = this.getCustomStorage('MaterLifeCustomColumn')
    // 同步本地存储自定义列
    if (shows.length) {
      const local_shows = shows
        .filter((ret) => ret)
        .map((ret) => {
          const item = columns.filter((met) => met.key === ret).pop() || {}
          item.show = false
          return item
        })
      const extend_shows = columns
        .filter((ret) => !shows.includes(ret.key))
        .map((ret) => {
          ret.show = true
          return ret
        })
      this.columns = [...local_shows, ...extend_shows]
    } else {
      this.columns = [...columns]
    }
    this.proLoadData()
  }
}
</script>
<style lang="scss" scoped>
.c-material-lifecycle {
  position: relative;
  height: 100%;

  .material-info-row {
    margin-bottom: 8px;
    > span {
      margin-right: 8px;
      .text {
        color: red;
      }
    }
  }

  .c-form {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .c-m-table {
    height: calc(100% - 49px);
    padding-top: 8px;

    ::v-deep .ivu-btn:hover {
      background-color: transparent;
    }

    .c-table-list {
      height: 44px;

      .c-pane {
        height: 100%;
      }
    }

    .c-compare-wrap {
      height: 350px;
      margin-bottom: 12px;
      padding: 8px 12px 0;
      background-color: #fff;

      .c-compare-form {
        width: 420px;
        height: 48px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-bottom: 8px;
      }

      .c-echarts {
        height: calc(100% - 48px);
      }
    }
  }

  .c-table-page {
    padding: 5px 0;
    text-align: right;
  }
}
</style>
